// Required dependencies
import 'jquery';
import { initFlowbite } from 'flowbite'

// Assets
// These assets are extracted to [id].bundle.css using MiniCssExtractPlugin, see more on webpack.config.js
import './theme/style.css';
import './theme/custom.scss';


import netteForms from 'nette-forms';
netteForms.initOnLoad();


import SwupSlideTheme from '@swup/slide-theme';
import Swup from 'swup';


const swup = new Swup({
    plugins: [new SwupSlideTheme({reversed: false})],
    containers: ['#swup', '#bannerTop'],
    animateHistoryBrowsing: true
});


swup.on('contentReplaced', function () {
    window.scrollTo(0, 0);
});

function init() {
    $('.rating').on('click', function () {
	var rating = this['value'];

	$('.feedback').css('display', "block");

	feedback_validate(rating);

    });
    naja.initialize.bind(naja);
    initFlowbite();

}


function starsRating(el) {
    var el = document.getElementById(el);
    var stars = el.querySelectorAll(".stars i");

// Loop through the "stars" NodeList
    stars.forEach((star, index1) => {
	// Add an event listener that runs a function when the "click" event is triggered
	star.addEventListener("click", () => {
	    // Loop through the "stars" NodeList Again
	    stars.forEach((star, index2) => {
		// Add the "active" class to the clicked star and any stars with a lower index
		// and remove the "active" class from any stars with a higher index
		index1 >= index2 ? star.classList.add("active") : star.classList.remove("active");
	    });
	});
    });
}


function feedback_validate(val) {
    if (val <= 3) {
	$('.feedback textarea').attr('placeholder', 'Mrzí nás, že jste nebyli s operací spokojeni. V čem se můžeme zlepšit?');

    } else if (val > 3) {
	$('.feedback textarea').attr('placeholder', 'Děkujeme za hodnocení. Chtěli byste nám něco vzkázat?');
    }


}



// run once when page loads
if (document.readyState === 'complete') {
    init();
} else {
    document.addEventListener('DOMContentLoaded', () => init());
}

// run after every additional navigation by swup
swup.on('contentReplaced', init);

import naja from "naja";

import './ui/confirm';

naja.initialize();